module.exports = __webpack_public_path__ + "static/img/SD.77797017.svg";